<template>
  <div id="contagens">
    <nav-menu ></nav-menu>

    <div 
      v-if="pesq_pro_spin"
      class="w3-modal" 
      style="z-index: 1;width: 100%; height: 100%; display: block; padding-top: 200px;">
      <p style="text-align: center">
        <i class="fa fa-sync-alt w3-spin" style="font-size: 50px; color: #fff"></i>
      </p>
    </div>

    <modal-codigo-barras 
      v-if="abrirModalLeitorCodigoBarras" 
      @codigo_barras="buscarPeloCodigoBarras" 
      @fechar_modal_codigo_barras="fecharLeitorCodigoBarras" 
    />
    
    <div class="w3-main w3-animate-left" style="margin-top:43px;">
      <header class="w3-container w3-padding-top" v-if="!iniciou_inventario">
        <h5 v-cloak>
          <b><i class="fa fa-th-list"></i> Inventário</b>
        </h5>
      </header>
      
      <div class="w3-container" v-if="!iniciou_inventario">
        <div class="w3-col m6 s12 l4 w3-padding-right w3-margin-bottom">
          <strong>Tipo de inventário</strong>
          <select class="w3-select w3-border" v-model="tipo_inventario">
            <option value="" default>Selecione</option>
            <option value="CON">CONTAGEM</option>
            <option value="REC">RECONTAGEM</option>
          </select>
        </div>
        
        <div class="w3-col m6 s12 l4 w3-padding-right w3-margin-bottom">
          <strong>Tipo de levantamento</strong>
          <select class="w3-select w3-border" v-model="tipo_levantamento">
            <option value="" default>Selecione</option>
            <option value="TOT">TOTAL</option>
            <option value="PAR">PARCIAL</option>
          </select>
        </div>
        
        <div class="w3-col s12 m12 l4 w3-margin-bottom">
          <strong>Referência de estoque</strong>
          <input 
            type="text" 
            class="w3-input w3-border label-clicavel"
            v-model="nome_referencia_estoque"
            @click="pesqRefMostrar()"
            placeholder="Clique aqui para selecionar a referência de estoque"
            readonly>
        </div>
        
        <div class="w3-cotainer">
          <div class="w3-col s12 w3-center w3-padding">
            <button 
              class="w3-button w3-theme"
              @click="iniciarInventario()" 
              v-cloak>
              Iniciar
              <i class="fa fa-toggle-right"></i>
            </button>
          </div>
        </div>
      </div>
      
      <div v-if="iniciou_inventario" v-cloak>
        <div class="w3-container">
          <header class="w3-center">
            <div class="w3-col s12 w3-left">
              <h5 class="titulo texto-vermelho">{{nome_referencia_estoque}}</h5>
            </div>
            
            <div class="w3-col s12 w3-left">
              <strong 
                v-if="tipo_inventario == 'CON' &&
                tipo_levantamento == 'TOT'">
                Contagem Total
              </strong>
              
              <strong
                v-if="tipo_inventario == 'CON' &&
                tipo_levantamento == 'PAR'">
                Contagem Parcial
              </strong>
              
              <strong 
                v-if="tipo_inventario == 'REC' &&
                tipo_levantamento == 'TOT'">
                Recontagem Total
              </strong>
              
              <strong 
                v-if="tipo_inventario == 'REC' && 
                tipo_levantamento == 'PAR'">
                Recontagem Parcial
              </strong>
            </div>
          </header>
          
          <div class="w3-bar w3-white w3-border">
            <div class="w3-col s4" @click="lancarProduto();">
              <button 
                class="w3-bar-item w3-transparent tablink botao-quadrado w3-text-theme tab-active" 
                :class=" {'active' : (pagina_atual == 'I')}" 
                style="width: 100%;cursor: pointer"
                @click="pagina_atual = 'I';">
                <i class="fa fa-plus-square icone-vermelho iconeVisivel"></i>
                <br class="w3-hide-large w3-hide-medium"> Inserir
              </button>
            </div>
            
            <div class="w3-col s4">
              <button 
                class="w3-bar-item w3-transparent botao-quadrado tablink w3-text-theme tab-active" 
                :class="{'active' : (pagina_atual == 'L')}"
                style="width: 100%;cursor: pointer" 
                @click="pagina_atual = 'L';">
                <i class="fa fa-list-ul icone-vermelho iconeVisivel"></i>
                <br class="w3-hide-large w3-hide-medium"> Lançados
              </button>
            </div>
            
            <div class="w3-col s4">
              <button 
                class="w3-bar-item w3-transparent botao-quadrado tablink w3-text-theme tab-active"
                :class="{'active' : (pagina_atual == 'F')}"
                style="width: 100%;cursor: pointer"
                @click="pagina_atual = 'F';">
                <i class="fa fa-certificate icone-vermelho iconeVisivel"></i>
                <br class="w3-hide-large w3-hide-medium"> Finalizar
              </button>
            </div>
          </div>

          <!-- ####################### PAINEL DE OPÇÕES DA PÁGINA LANÇAMENTOS ####################### -->
          <div class="w3-margin-top" v-show="pagina_atual == 'L'">
            <div class="w3-col s6 " v-show="lancamentos_produtos.length > 0">
              <h5 class="totalizador">Últimos lançamentos</h5>
            </div>
            
            <div class="w3-col s6" v-show="lancamentos_produtos.length > 0">
              <div class="w3-dropdown-hover w3-right">
                <button class="w3-button w3-theme w3-padding">
                  <i class="fas fa-sort"></i> 
                  Ordenar
                </button>
                
                <div 
                  class="w3-dropdown-content w3-bar-block w3-border" 
                  style="right: 0; width: 210px;">
                  <div>
                    <button 
                      class="w3-bar-item w3-button" 
                      @click="tipo_ordenacao_lancamentos = 'LAN'">
                      
                      <i 
                        class="fa fa-check-square-o icone-vermelho" 
                        v-show="tipo_ordenacao_lancamentos == 'LAN'">
                      </i>
                      <i 
                        class="fa fa-square-o"
                        style="color: #cccccc;"
                        v-show="tipo_ordenacao_lancamentos != 'LAN'">
                      </i>
                      Lançamento
                    </button>
                  </div>
                  
                  <div>
                    <button 
                      class="w3-bar-item w3-button" 
                      @click="tipo_ordenacao_lancamentos = 'NOM'">
                      
                      <i 
                        class="fa fa-check-square-o icone-vermelho" 
                        v-show="tipo_ordenacao_lancamentos == 'NOM'">
                      </i>
                      
                      <i 
                        class="fa fa-square-o" 
                        style="color: #cccccc;"
                        v-show="tipo_ordenacao_lancamentos != 'NOM'">
                      </i>
                      Nome
                    </button>
                  </div>
                  
                  <div>
                    <button class="w3-bar-item w3-button" @click="tipo_ordenacao_lancamentos = 'COD'">
                      <i 
                        class="fa fa-check-square-o icone-vermelho"
                        v-show="tipo_ordenacao_lancamentos == 'COD'">
                      </i>
                      <i 
                        class="fa fa-square-o" 
                        style="color: #cccccc;"
                        v-show="tipo_ordenacao_lancamentos != 'COD'">
                      </i>
                      Código
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ####################### PAINEL DE OPÇÕES DA PÁGINA FINALIZACAO ####################### -->
          <div v-show="pagina_atual == 'F' && contagem_produtos.length > 0">
            <div class="w3-col s6 w3-margin-top">
              <button
                class="w3-button w3-theme w3-left"
                @click="gravarContagem()">
                <i class="fas fa-save"></i>
                Gravar
              </button>
            </div>
            
            <div class="w3-dropdown-hover w3-right w3-margin-top">
              <button class="w3-button w3-theme w3-padding">
                <i class="fas fa-sort"></i>
                Ordenar
              </button>
              
              <div 
                class="w3-dropdown-content w3-bar-block w3-border"
                style="right: 0; width: 210px;">
                <div>
                  <button 
                    class="w3-bar-item w3-button"
                    @click="tipo_ordenacao_contagem = 'COD'">
                    
                    <i
                      class="fa fa-check-square-o icone-vermelho"
                      v-show="tipo_ordenacao_contagem == 'COD'">
                    </i>
                    <i 
                      class="fa fa-square-o" 
                      style="color: #cccccc;" 
                      v-show="tipo_ordenacao_contagem != 'COD'">
                    </i>
                    Código
                  </button>
                </div>
                
                <div>
                  <button 
                    class="w3-bar-item w3-button"
                    @click="tipo_ordenacao_contagem = 'NOM'">
                    <i
                      class="fa fa-check-square-o icone-vermelho"
                      v-show="tipo_ordenacao_contagem == 'NOM'">
                    </i>
                    <i 
                      class="fa fa-square-o" 
                      style="color: #cccccc;"
                      v-show="tipo_ordenacao_contagem != 'NOM'">
                    </i>
                    Nome
                  </button>
                </div>
              </div>
            </div>
            
            <div class="w3-col s12">
              <h5 class="totalizador">Totais das leituras</h5>
            </div>
          </div>
        </div>

        <!-- Inicio de div de inserção de itens -->
        <div 
          class="w3-row-padding w3-margin-bottom pagina_insercao" 
          v-show="pagina_atual == 'I'" 
          v-cloak>
          <hr>
          <div class="w3-col s6 m6 l4">
            <strong>Cód. barras / produto</strong>
            <input 
              id="campo_codigo_digitado" 
              ref="campo_codigo_digitado"
              type="number" 
              maxlength="16" 
              class="w3-input w3-border campo" 
              v-model="codigo_digitado" 
              @keyup.enter="insercaoDiretaProduto"
              autofocus/>
          </div>
          
          <div class="w3-col s3 m3 l1">
            <br>
            <button
              class="w3-button w3-text-theme w3-block w3-border w3-border-theme"
              @click="lerCodigoBarras()">
              <i class="fa fa-camera"></i>
            </button>
          </div>
          
          <div class="w3-col s3 m3 l1">
            <br>
            <button
              class="w3-button w3-text-theme w3-block w3-border w3-border-theme"
              @click="pesqProMostrar()">
              <i class="fa fa-search"></i>
            </button>
          </div>
          
          <div class="w3-col s12 m12 l4">
            <strong>Quantidade</strong>
            <input 
              type="number"
              maxlength="18"
              class="w3-input w3-border campo w3-block" 
              v-model="quantidade_digitada_str"
              @keyup.enter="insercaoDiretaProduto"/>
          </div>
          
          <div class="w3-col s12 m12 l2 w3-left">
            <br>
            <button
              class="w3-button w3-theme w3-block w3-border w3-border-theme"
              @click="insercaoDiretaProduto()">
              <i class="fa fa-check"></i>
              Confirmar
            </button>
          </div>
          
          <div class="w3-col s12 w3-margin-top w3-margin-right">
            <input 
              id="som_sucesso"
              type="checkbox"
              v-model="beep_som_sucesso">
              
            <label 
              class="titulo-checkbox" 
              for="som_sucesso">
              Beep em leitura com sucesso
            </label>
          </div>
        </div>
        
        <input 
          id="focus_input_aux" 
          type="text" 
          class="w3-hide"/>
      </div>

      <!-- Deve ficar fora de v-show pois o javascript precisa encontra da DOM -->
      <div>
        <audio controls id="alerta-poket" hidden preload="auto">
          <source 
            src="../assets/audio/alertapocket.mp3"
            type="audio/mpeg"> 
            Seu browser não suporta o uso de arquivos no formato mp3
        </audio>
        
        <audio 
          controls id="leitura-poket"
          hidden preload="auto">
          <source
            src="../assets/audio/leiturapocket.mp3" 
            type="audio/mpeg"> 
            Seu browser não suporta o uso de arquivos no formato mp3
        </audio>
      </div>

      <div 
        class="w3-container" 
        v-show="pagina_atual == 'L'"
        v-cloak>
        <div 
          class="w3-padding-top label-clicavel"
          v-for="(lancamento) in buscarItensLancamentoOrdenados"
          @click="alternarDetalhesLancamento(lancamento.lancamento_id)">
          
          <div class="w3-col s12" style="padding-bottom: 0 !important;">
            <div class="w3-col s12 w3-padding" style="border-top: 2px dotted #bbbbbb; margin-top: 12px;">
              <div class="w3-col s12 m6">
                <i 
                  class="fa fa-arrow-circle-right icone-vermelho"
                  v-show="!lancamento.mostrar_detalhes">
                </i>
                
                <i 
                  class="fa fa-arrow-circle-down icone-vermelho" 
                  v-show="lancamento.mostrar_detalhes">
                </i>
                <strong>{{formatarProdutoId(lancamento.produto_id, 0)}} - {{lancamento.nome}}</strong>
              </div>
              
              <div class="w3-col s6 m6 w3-hide-small" style="padding-left: 20px">
                <label>Quantidade</label>
                <strong>{{ `${formatarValor(lancamento.quantidade)} - ${lancamento.unidade}` }}</strong>
              </div>
            </div>
            
            <div class="w3-row-padding ">
            
              <div 
                class="w3-col s12 m4 w3-margin-top"  
                v-if="temControleLoteComPiso(lancamento.tipo_controle_estoque)">
                <div class="w3-col s4 m4 line-item">
                  <label class="w3-left titulo-small">Bitola</label>
                </div>
                
                <div class="w3-col s8 m8 line-item">
                  <strong class="w3-right" v-if="lancamento.bitola">
                    {{ lancamento.bitola.slice(-1) === '-' ?  lancamento.bitola.slice(0, -1) : lancamento.bitola }}
                  </strong>
                  <strong class="w3-right" v-else style="margin-top: 22px;"></strong>
                </div>
              </div>
            
              <div 
                class="w3-col s12 m4 w3-margin-top"
                v-if="temControleLoteComPiso(lancamento.tipo_controle_estoque)">
                
                <div class="w3-col s5 m5 line-item">
                  <label class="w3-left titulo-small">Tonalidade</label>
                </div>
                
                <div class="w3-col s7 m7 line-item">
                  <strong 
                    class="w3-right" 
                    v-if="lancamento.tonalidade">
                    {{ lancamento.tonalidade.slice(-1) === '-' ?  lancamento.tonalidade.slice(0, -1) : lancamento.tonalidade}}
                  </strong>
                  <strong class="w3-right" v-else style="margin-top: 22px;"></strong>
                </div>
              </div>

              <div 
                class="w3-col s12 m4 w3-margin-top"  
                v-if="temControleLote(lancamento.tipo_controle_estoque) && lancamento.tipo_controle_estoque != 'P'">
                <div class="w3-col s4 m4 line-item">
                  <label class="w3-left titulo-small">Lote</label>
                </div>
                
                <div class="w3-col s8 m8 line-item">
                  <strong class="w3-right" v-if="lancamento.lote">
                    {{ lancamento.lote.slice(-1) === '-' ?  lancamento.lote.slice(0, -1) : lancamento.lote }}
                  </strong>
                  <strong class="w3-right" v-else style="margin-top: 22px;"></strong>
                </div>
              </div>
            
              <div 
                class="w3-col s12 m4 w3-margin-top" 
                v-if="lancamento.exigir_data_fabricacao == 'S'  && 
                lancamento.mostrar_detalhes">
                
                <div class="w3-col s6 m6 line-item">
                  <label 
                    class="w3-left titulo-small" 
                    v-if="lancamento.exigir_data_fabricacao == 'S'">
                    Fabricação
                  </label>
                </div>
                
                <div class="w3-col s6 m6 line-item">
                  <strong class="w3-right" v-if="lancamento.data_fabricacao">
                    {{ lancamento.data_fabricacao }}
                  </strong>
                  <strong class="w3-right" v-else style="margin-top: 22px;"></strong>
                </div>
              </div>
            
              <div 
                class="w3-col s12 m4 w3-margin-top" 
                v-if="lancamento.exigir_validade == 'S'  &&
                lancamento.mostrar_detalhes">
                
                <div class="w3-col s6 m6 line-item">
                  <label 
                    class="w3-left titulo-small" 
                    v-if="lancamento.exigir_validade == 'S'">
                    Vencimento
                  </label>
                </div>
                
                <div class="w3-col s6 m6 line-item">
                  <strong class="w3-right" v-if="lancamento.vencimento">
                    {{ lancamento.vencimento }}
                  </strong>
                  <strong class="w3-right" v-else style="margin-top: 22px;"></strong>
                </div>
              </div>
              
              <div 
                class="w3-col s12 m4 w3-margin-top" 
                v-show="lancamento.mostrar_detalhes  && 
                lancamento.mostrar_detalhes">
                
                <div class="w3-col s6 m6 line-item">
                  <label class="w3-left titulo-small">Ordem</label>
                </div>
                
                <div class="w3-col s6 m6 line-item">
                  <strong class="w3-right">{{ `${lancamento.lancamento_id}ª leitura`}}</strong>
                </div>
              </div>
            
              <div 
                class="w3-col s12 m4 w3-margin-top"
                v-show="lancamento.mostrar_detalhes  && 
                lancamento.mostrar_detalhes">
                
                <div class="w3-col s5 m5 line-item">
                  <label class="w3-left titulo-small">Marca</label>
                </div>
                
                <div class="w3-col s7 m7 line-item">
                  <strong class="w3-right">{{ lancamento.marca }}</strong>
                </div>
              </div>
            
              <div 
                class="w3-col s12 m4 w3-margin-top"
                v-show="lancamento.mostrar_detalhes &&
                (lancamento.codigo_original != undefined) &&
                (lancamento.codigo_original != '')">
                
                <div class="w3-col s6 m6 line-item">
                  <label class="w3-left titulo-small">Cód. original</label>
                </div>
                
                <div class="w3-col s6 m6 line-item">
                  <strong class="w3-right">{{ lancamento.codigo_original }}</strong>
                </div>
              </div>
            
              <div 
                class="w3-col s12 m4 w3-margin-top"
                v-show="lancamento.mostrar_detalhes && 
                (lancamento.codigo_barras != undefined) && 
                (lancamento.codigo_barras != '')">
                
                <div class="w3-col s6 m6 line-item">
                  <label class="w3-left titulo-small">Cód. barras</label>
                </div>
                
                <div class="w3-col s6 m6 line-item">
                  <strong class="w3-right">{{ lancamento.codigo_barras }}</strong>
                </div>
              </div>
            
              <div 
                class="w3-col s12 m4 w3-margin-top"
                v-show="lancamento.mostrar_detalhes && 
                lancamento.produto_pai > 0">
                
                <div class="w3-col s6 m6 line-item">
                  <label class="w3-left titulo-small">Produto filho</label>
                </div>
                
                <div class="w3-col s6 m6 line-item">
                  <strong class="w3-right">Sim</strong>
                </div>
              </div>
              
              <div 
                class="w3-col s12 m4 w3-margin-top" 
                v-show="lancamento.mostrar_detalhes && 
                lancamento.produto_ref != 
                lancamento.produto_id">
                
                <div class="w3-col s6 m6 line-item">
                  <label class="w3-left titulo-small">Produto pai</label>
                </div>
                
                <div class="w3-col s6 m6 line-item">
                  <strong class="w3-right">{{ lancamento.produto_ref }}</strong>
                </div>
              </div>
            
              <div class="w3-col s12 m4 w3-margin-top" v-show="lancamento.mostrar_detalhes">
                <div class="w3-col s6 m6 line-item">
                  <label class="w3-left titulo-small">Quantidade</label>
                </div>
                <div class="w3-col s6 m6 line-item">
                  <strong class="w3-right">
                    {{ `${formatarValor(lancamento.quantidade, 3)} - ${lancamento.unidade}` }}
                  </strong>
                </div>
              </div>
              
              <div 
                class="w3-col s12 w3-center w3-margin-top w3-margin-bottom align-button-center" 
                v-show="lancamento.mostrar_detalhes">
                
                <button 
                  class="w3-button w3-theme w3-col l3 m3 w3-mobile" 
                  @click="excluirLancamento(lancamento)" 
                  v-cloak>
                  <i class="fa fa-minus-circle"></i> Excluir
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ##################### PÁGINA DE TOTALIZAÇÃO ##################### -->
      <div 
        class="w3-container w3-margin-top w3-margin-bottom"
        v-show="contagem_produtos.length == 0 && 
        iniciou_inventario"
        v-cloak>
        
        <div class="w3-col s12">
          <strong>Não há lançamentos.</strong>
        </div>
      </div>
      
      <div class="w3-container" v-show="pagina_atual == 'F'" v-cloak>
        <div 
          class="label-clicavel"
          v-for="(produto) in buscarItensInventarioOrdenados">
          <div 
            class="w3-col s12 w3-padding" 
            style="border-top: 2px dotted #bbbbbb;" 
            @click="alternarDetalhesContagem(produto.produto_id)">
            
            <div class="w3-col s12 m6">
              <i class="fa fa-arrow-circle-right icone-vermelho" v-show="!produto.mostrar_detalhes"></i>
              <i class="fa fa-arrow-circle-down icone-vermelho" v-show="produto.mostrar_detalhes"></i>
              <strong>{{formatarProdutoId(produto.produto_id, 0)}} - {{produto.nome}}</strong>
            </div>
            
            <div class="w3-col s6 m6 w3-hide-small">
              <label class="w3-left titulo-small">Total </label>
              <strong class="w3-padding-left">{{ `${formatarValor(produto.quantidade)} - ${produto.unidade}` }}</strong>
            </div>
          </div>
          
          <div 
            class="w3-row-padding w3-margin-bottom" 
            v-show="produto.mostrar_detalhes"
            @click="alternarDetalhesContagem(produto.produto_id)">
            
            <div class="w3-col s12 m4 w3-margin-top">
              <div class="w3-col s6 m6 line-item">
                <label class="w3-left titulo-small">Marca</label>
              </div>
              
              <div class="w3-col s6 m6 line-item">
                <strong class="w3-right">{{produto.marca}}</strong>
              </div>
            </div>
            
            <div 
              class="w3-col s12 m4 w3-margin-top" 
              v-show="(produto.codigo_original != undefined) &&
              (produto.codigo_original != '')">
              
              <div class="w3-col s6 m6 line-item">
                <label class="w3-left titulo-small">Cód. original</label>
              </div>
              
              <div class="w3-col s6 m6 line-item">
                <strong class="w3-right">{{produto.codigo_original}}</strong>
              </div>
            </div>
            
            <div 
              class="w3-col s12 m4 w3-margin-top"
              v-show="(produto.codigo_barras != undefined) &&
              (produto.codigo_barras != '')">
              
              <div class="w3-col s6 m6 line-item">
                <label class="w3-left titulo-small">Cód. barras</label>
              </div>
              
              <div class="w3-col s6 m6 line-item">
                <strong class="w3-right">{{produto.codigo_barras}}</strong>
              </div>
            </div>
            
            <div class="w3-col s12 m4 w3-margin-top" v-show="produto.produto_pai > 0">
              <div class="w3-col s6 m6 line-item">
                <label class="w3-left titulo-small">CProduto filho</label>
              </div>
              
              <div class="w3-col s6 m6 line-item">
                <strong class="w3-right">Sim</strong>
              </div>
            </div>
            
            <div 
              class="w3-col s12 m4 w3-margin-top" 
              v-show="(produto.produto_ref != 
              produto.produto_id)">
              
              <div class="w3-col s6 m6 line-item">
                <label class="w3-left titulo-small">Produto pai</label>
              </div>
              
              <div class="w3-col s6 m6 line-item">
                <strong class="w3-right">{{produto.produto_ref}}</strong>
              </div>
            </div>
            
            <div class="w3-col s12 m4 w3-margin-top w3-hide-medium w3-hide-large">
              <div class="w3-col s6 m6 line-item">
                <label class="w3-left titulo-small">Total</label>
              </div>
              
              <div class="w3-col s6 m6 line-item">
                <strong class="w3-right">{{ `${produto.unidade}` }}</strong>
              </div>
            </div>
          </div>
          
          <div 
            class="w3-col s12 w3-row-padding" 
            v-if="temControleLote(produto.tipo_controle_estoque)"
            @click="alternarLotes(produto.produto_id)">
            
            <strong class="w3-left w3-row-padding" style="text-decoration: underline;">
              Ver lotes ({{produto.dados_lotes.length}})
            </strong>
          </div>
          
          <div 
            v-if="produto.mostrar_lotes && 
            temControleLote(produto.tipo_controle_estoque)"
            class="w3-row-padding">
            
            <div
              v-for="(lote) in produto.dados_lotes" 
              @click="alternarLotes(produto.produto_id)" >
              
              <div class="w3-col s12 w3-row-padding" v-if="temControleLoteComPiso(produto.tipo_controle_estoque)">
                <label class="w3-left titulo-small">Bitola</label>
                <strong class="w3-left w3-padding-left"> {{lote.bitola}} </strong>
              </div>

              <div class="w3-col s12 w3-row-padding" v-if="temControleLoteComPiso(produto.tipo_controle_estoque)">
                <label class="w3-left titulo-small">Tonalidade</label>
                <strong class="w3-left w3-padding-left"> {{lote.tonalidade}} </strong>
              </div>
              
              <div class="w3-col s12 w3-row-padding" v-if="temControleLote(produto.tipo_controle_estoque) && produto.tipo_controle_estoque != 'P'">
                <label class="w3-left titulo-small">Lote</label>
                <strong class="w3-left w3-padding-left"> {{lote.lote}} </strong>
              </div>
              
              <div class="w3-col s12 w3-row-padding w3-margin-bottom" style="border-bottom: 1px solid #dddddd;">
                <label class="w3-left titulo-small">Total lote</label>
                <strong class="w3-left w3-padding-left">
                  {{ `${formatarValor(lote.quantidade)} - ${produto.unidade}` }}
                </strong>
              </div>
              
            </div>
          </div>
        </div>
      </div>

      <!-- Inicio modal de pesquisa de produtos -->
      <div id="pesqProModal" class="w3-modal">
        <div class="w3-modal-content w3-animate-zoom">
          <header class="w3-container">
            <h4 class="texto-vermelho titulo">
              <i class="fa fa-search"></i> 
              Pesquisa de produto
            </h4>
            
            <span 
              @click="pesqProOcultar();
              focusCampoCodigoBarra()"
              class="w3-button w3-display-topright">
              &times;
            </span>
          </header>
          
          <div class="w3-container" v-show="pesq_pro_processando">
            <div class="w3-panel w3-theme w3-card-2">
              <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
            </div>
          </div>
          
          <div 
            id="pesqProCamposFiltros" 
            class="w3-row-padding w3-margin-bottom"
            v-show="(!pesq_pro_processando) && 
            pesq_pro_mostrar_filtros">
            
            <div :class="buscarClasseEditProduto">
              <strong>{{pesq_pro_titulo_filtro_1}}</strong>
              <input 
                id="pesq_pro_filtro_1" 
                ref="pesq_pro_filtro_1" 
                :type="pesq_pro_tipo_campo_1"
                :maxlength="pesq_pro_tamanho_maximo_1"
                class="w3-input w3-border input-upper"
                v-model="pesq_pro_filtro_digitado_1" 
                :placeholder="pesq_pro_texto_placeholder_1"
                @keyup.enter="pesqProTeclarEnterFiltro1"
                autofocus/>
            </div>
            
            <div :class="buscarClasseEditProduto" v-if="pesq_pro_tem_filtro_2">
              <strong>{{pesq_pro_titulo_filtro_2}}</strong>
              <input 
                id="pesq_pro_filtro_2"
                type="text" 
                class="w3-input w3-border input-upper " 
                v-model="pesq_pro_filtro_digitado_2"
                :placeholder="pesq_pro_texto_placeholder_2"
                @keyup.enter="pesqProPesquisar()" />
            </div>
          </div><br>
          
          <div 
            class="w3-col s12 m12 s12 w3-center w3-margin-bottom" 
            v-show="!pesq_pro_processando">
            
            <button class="w3-button w3-theme" @click="pesqProPesquisar()">
              <i class="fa fa-search"></i> Pesquisar
            </button>
            
            <div class=" w3-dropdown-hover w3-center">
              <button class="w3-button w3-theme-light">
                <i class="fa fa-cog"></i>
              </button>
              
              <div 
                class="w3-dropdown-content w3-bar-block w3-border" 
                style="right: 0; width: 210px;">
                
                <div 
                  v-for="(filtro) in pesq_pro_tipos_pesquisa">
                  <button class="w3-bar-item w3-button" @click="pesqProDefinirPesquisa(filtro.indice_tela)">
                    <i class="fa fa-check-square-o icone-vermelho" v-show="pesq_pro_opcao_filtro == filtro.indice_tela"></i>
                    <i 
                      class="fa fa-square-o" 
                      style="color: #dddddd;" 
                      v-show="pesq_pro_opcao_filtro != filtro.indice_tela">
                    </i>
                    {{filtro.descricao_pesquisa}}
                  </button>
                </div>
              </div>
            </div>
            
            <button 
              class="w3-button w3-theme-light"
              @click="pesqProAlternarFiltros()" 
              v-show="false">
              <i class="fa fa-compress" v-show="pesq_pro_mostrar_filtros"></i>
              <i class="fa fa-arrows-alt" v-show="!pesq_pro_mostrar_filtros"></i>
            </button>
          </div>
          
          <div class="w3-row-padding">
            <div 
              class="w3-col s12"
              style="max-height: calc(100vh - 340px);min-height: 320px;overflow: auto;" 
              v-show="pesq_pro_produtos_filtrados.length > 0">
              
              <table class="w3-table-all w3-hide-small w3-hide-medium">
                <thead>
                  <tr>
                    <th class="alinhamento-numero">Código</th>
                    <th>Nome</th>
                    <th>Marca</th>
                    <th>Un.</th>
                    <th>Ativo</th>
                    <th>Cód.original</th>
                    <th>Filho</th>
                    <th>Pai</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(produto) in pesq_pro_produtos_filtrados" 
                    :class="buscarClasseProdutoSelecionado(produto.produto_id, true)"
                    @click="pesqProSelecionarProduto(produto)"
                    style="cursor: pointer" v-cloak>
                    
                    <td class="alinhamento-numero">{{formatarProdutoId(produto.produto_id)}}</td>
                    <td>{{produto.nome}}</td>
                    <td>{{produto.marca_id}} - {{produto.nome_marca}}</td>
                    <td>{{produto.unidade}}</td>
                    <td>
                      <i 
                        style="color: #228e44; display: block; text-align: center;"
                        class="fa fa-circle" 
                        v-if="produto.ativo == 'S'">
                      </i>
                      <i 
                        style="color: #9c1d1c; display: block; text-align: center;" 
                        class="fa fa-circle"
                        v-if="produto.ativo == 'N'">
                      </i>
                    </td>
                    <td>{{produto.codigo_original}}</td>
                    <td>{{((produto.e_produto_filho == 'S') ? 'Sim' : '')}}</td>
                    <td>{{produto.produto_pai}}</td>
                  </tr>
                </tbody>
              </table>

              <div id="pesqProLista" class="w3-hide-large">
                <div 
                  v-for="(produto) in pesq_pro_produtos_filtrados"
                  @click="pesqProSelecionarProduto(produto)" 
                  v-cloak>
                  
                  <div :class="buscarClasseProdutoSelecionado(produto.produto_id, false)">
                    <div class="w3-col s12">
                      <div>
                        <hr>
                        <i 
                          style="color: #228e44; text-align: center;"
                          class="fa fa-circle" 
                          v-if="produto.ativo == 'S'">
                        </i>
                        <i 
                          style="color: #bbbbbb; text-align: center;"
                          class="fa fa-circle" 
                          v-if="produto.ativo == 'N'">
                        </i>
                        <strong>{{formatarProdutoId(produto.produto_id, 0)}} - {{produto.nome}}</strong>
                      </div>
                    </div>
                    
                    <div class="w3-col s12">
                      <label class="w3-left titulo-small">Marca</label>
                      <strong class="w3-right">{{produto.marca}}</strong>
                    </div>
                    
                    <div class="w3-col s12">
                      <label class="w3-left titulo-small">Unidade</label>
                      <strong class="w3-right">{{produto.unidade}}</strong>
                    </div>
                    
                    <div 
                      class="w3-col s12"
                      v-show="(produto.codigo_original != undefined) &&
                      (produto.codigo_original != '')">
                      
                      <label class="w3-left titulo-small">Código original:</label>
                      <strong class="w3-right">{{produto.codigo_original}}</strong>
                    </div>
                    
                    <div class="w3-col s12" v-show="produto.e_produto_filho == 'S' ">
                      <label class="w3-left titulo-small">Produto filho</label>
                      <strong class="w3-right">Sim</strong>
                    </div>
                    
                    <div class="w3-col s12" v-show="produto.produto_pai > 0">
                      <label class="w3-left titulo-small">Produto pai</label>
                      <strong class="w3-right">{{produto.produto_pai}}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Fim modal de pesquisa de produtos -->

      <!-- ##################### MODAL DE DEFINÇÃO DO LOTE ##################### -->
      <div id="buscarLoteModal" ref="buscarLoteModal" class="w3-modal">
        <div class="w3-modal-content w3-animate-zoom">
          <header class="w3-container">
            <span @click="buscarLoteOcultar()" class="w3-button w3-display-topright">&times;</span>
            <h4 class="texto-vermelho titulo">Definir lote</h4>
            <h5>{{nome_produto_buscar_lote}}</h5>
          </header>
          
          <div class="w3-row-padding  w3-margin-bottom">            
            <div class="w3-col m2 s12 w3-white" v-show="coletar_bitola">
              <strong>Bitola</strong>
              <input
                id="campo_bitola" 
                ref="campo_bitola" 
                type="text" 
                :maxlength="3"
                class="w3-input w3-border input-upper"
                v-model="bitola_digitada"
                @keyup.enter="teclaEnterLote('campo_bitola')" 
                autofocus />
            </div>
            
            <div class="w3-col m2 s12" v-show="coletar_tonalidade">
              <strong>Tonalidade</strong>
              <input 
                id="campo_tonalidade"
                ref="campo_tonalidade"
                type="text"
                maxlength="17"
                class="w3-input w3-border input-upper"
                v-model="tonalidade_digitada"  
                @keyup.enter="teclaEnterLote('campo_tonalidade')" />
            </div>

            <div class="w3-col m4 s12 w3-white" v-show="coletar_lote">
              <strong>Lote</strong>
              <input
                id="campo_lote" 
                ref="campo_lote" 
                type="text" 
                :maxlength="tamanho_maximo_campo_lote"
                class="w3-input w3-border input-upper"
                v-model="lote_digitado"
                @keyup.enter="teclaEnterLote('campo_lote')" />
            </div>
            
            <div class="w3-col m4 s12" v-show="coletar_data_fabricacao">
              <strong>Data de fabricação</strong>
              <input 
                id="campo_data_fabricacao" 
                class="w3-input w3-border"
                type="text" 
                v-model="data_fabricacao_digitada"
                v-mask="'##/##/####'"
                @keyup.enter="teclaEnterLote('campo_data_fabricacao')">
            </div>
            
            <div class="w3-col m4 s12" v-show="coletar_validade">
              <strong>Data de validade</strong>
              <input 
                id="campo_data_validade" 
                class="w3-input w3-border"
                type="text"
                v-model="data_validade_digitada"
                v-mask="'##/##/####'"
                @keyup.enter="teclaEnterLote('campo_data_validade')">
            </div>
            
            <div class="w3-col m4 s12">
              <br>
              <button 
                class="w3-button w3-theme" 
                style="float: right; width: 100%; max-width: 200px;"
                @click="definirLoteManual()"
                v-cloak>
                <i class="fa fa-check"></i> Definir
              </button>
            </div>
          </div>
          
          <div class="w3-row-padding">
            <div
              class="w3-col s12" 
              style="max-height: calc(75vh - 320px); min-height: 200px; overflow: auto;"
              v-show="lotes_item_selecionado.length > 0">
            </div>
          </div>
        </div>
      </div>

      <!-- Inicio modal de pesquisa de referência de estoque -->
      <div id="pesqRefModal" class="w3-modal">
        <div class="w3-modal-content w3-animate-zoom">
          <header class="w3-container" >
            <span @click="pesqRefOcultar()" class="w3-button w3-display-topright">&times;</span>
            <h4 v-if="empresa_utiliza_wms != 'S'" class="texto-vermelho titulo">Pesquisa de referências de estoque</h4>
            <h4 v-else class="texto-vermelho titulo">Pesquisar endereços de WMS</h4>
            
            <div class="w3-row-padding w3-margin-bottom" style="padding:0">
              <div class="w3-col m12 s12" style="padding: 0" >
                <strong v-if="empresa_utiliza_wms != 'S'">{{pesq_ref_titulo_filtro}}</strong>
                <strong v-else>Descrição</strong>
                <input 
                  id="pesq_ref_filtro" 
                  ref="pesq_ref_filtro" 
                  type="text" 
                  maxlength="30" 
                  class="w3-input w3-border input-upper" 
                  v-model="pesq_ref_filtro_digitado" 
                  placeholder="Todos" 
                  autofocus/>
              </div>
              
              <div class="w3-col s12 m12 s12 w3-center w3-margin-top" >
                <button class="w3-button w3-theme" @click="pesqRefPesquisar()">
                  <i class="fa fa-search"></i> Pesquisar</button>
                  
                <div class=" w3-dropdown-hover w3-center w3-animate-left">
                  <button class="w3-button w3-theme">
                    <i class="fa fa-cog"></i>
                  </button>
                  
                  <div class="w3-dropdown-content w3-bar-block w3-border" style="right: 0; width: 210px;">
                    <div v-for="(filtro) in pesq_ref_tipos_pesquisa">
                      <button
                        class="w3-bar-item w3-button" 
                        v-if="empresa_utiliza_wms != 'S'" 
                        @click="pesqRefDefinirPesquisa(filtro.indice_tela)">
                        <i 
                          class="fa fa-check-square-o icone-vermelho"
                          v-show="pesq_ref_opcao_filtro == filtro.indice_tela">
                        </i>
                        <i 
                          class="fa fa-square-o" 
                          style="color: #cccccc;" 
                          v-show="pesq_ref_opcao_filtro != 
                          filtro.indice_tela">
                        </i>
                        {{filtro.descricao_pesquisa}}
                      </button>
                    </div>
                    
                    <div  v-for="(filtro) in pesq_ref_tipos_pesquisa_wms">
                      <button class="w3-bar-item w3-button" v-if="empresa_utiliza_wms == 'S'">
                        <i 
                          class="fa fa-check-square-o icone-vermelho"
                          v-show="pesq_ref_opcao_filtro == 
                          filtro.indice_tela">
                        </i>
                        <i 
                          class="fa fa-square-o" 
                          style="color: #cccccc;" 
                          v-show="pesq_ref_opcao_filtro != 
                          filtro.indice_tela">
                        </i>
                        {{filtro.descricao_pesquisa}}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
          </header>
          <div class="w3-row-padding">
            <div class="w3-container" v-if="pesq_pro_processando">
              <div class="w3-panel w3-theme w3-card-2">
                <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
              </div>
            </div>
            
            <div 
              class="w3-col s12"
              v-show="pesq_ref_referencias_estoque_filtradas.length > 0 &&
              !pesq_pro_processando" 
              v-cloak>
              
              <div class="w3-margin-top w3-margin-bottom w3-hide-small w3-hide-medium">
                <div
                  class="w3-responsive w3-border" 
                  style="max-height: calc(75vh - 320px);min-height: 200px;overflow: auto">
                  <table class="w3-table-all">
                    <thead>
                      <tr>
                        <th v-if="empresa_utiliza_wms == 'N'" class="alinhamento-numero">Referência</th>
                        <th v-else class="alinhamento-numero">Endereço</th>
                        <th>Nome</th>
                        <th>Local</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr 
                        class="label-clicavel" 
                        v-for="(referencia) in referenciaEstoqueFiltrados"
                        @click="pesqRefSelecionar(referencia)" 
                        :class="buscarClasseProdutoSelecionado(referencia.referencia_estoque_id, false)" 
                        v-cloak>
                        <td class="alinhamento-numero">{{pesqRefFormatarReferencia(referencia.referencia_estoque_id)}}</td>
                        <td>{{referencia.nome}}</td>
                        <td>{{referencia.nome_local}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              
              <div class="w3-hide-large">
                <div 
                  v-for="(referencia) in referenciaEstoqueFiltrados"
                  @click="pesqRefSelecionar(referencia)"
                  v-cloak>
                  <div 
                    class="w3-col s12 label-clicavel" 
                    style="border-bottom: 2px dotted #bbbbbb; margin: 2px 0 3px 0;">
                    
                    <div class="w3-col s12" style="padding-top: 10px;">
                      <div>
                        <strong>
                          {{pesqRefFormatarReferencia(referencia.referencia_estoque_id, 0)}} - {{referencia.nome}}
                        </strong>
                      </div>
                    </div>
                    
                    <div class="w3-col s12">
                      <label>Local</label>
                      <strong>{{referencia.nome_local}}</strong>
                    </div>
                  </div>
                </div>
              </div>
              <paginacao
                  @pagina="mudarPagina"
                  :pagina-atual="paginaAtual"
                  :itens-por-pagina="itensPorPagina"
                  :total-resultados="totalResultados"
                  :total-de-paginas="totalDePaginas"
                />
            </div>
          </div>
        </div>
      </div>
      <!-- Fim modal de pesquisa de referência de estoque -->
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import VueMask from 'v-mask';
import VueNumeric from 'vue-numeric'
import NavMenu from '@/components/Menu'
import Paginacao from "@/components/Paginacao";
import RInventario from "@/components/Rest/RInventario.js";
import formatarValorMixin from '@/mixins/formatarValorMixin';
import Biblioteca from '@/components/Repositorio/Biblioteca.js';
import ModalCodigoBarras from '@/components/Orcamentos/ModalCodigoBarras'
import RProdutoBuscarProdutoPesquisa from "@/components/Rest/RProduto/RProdutoBuscarProdutoPesquisa.js";
import RProdutoBuscarProdutoPorIdOuCodigoBarras from "@/components/Rest/RProduto/RProdutoBuscarProdutoPorIdOuCodigoBarras.js";

export default {
  name: 'Contagens',
  mixins: [formatarValorMixin],
  components: {
    VueNumeric,
    NavMenu,
    VueMask,
    Paginacao,
    ModalCodigoBarras
  },
  data () {
    return {
      api: process.env.API,
      tipo_inventario: '',       /* CON - Contagem    REC - Recontagem */
      tipo_levantamento: '',     /* TOT - Total       PAR - Parcial */
      codigo_digitado: '',
      quantidade_digitada_str: '1',
      nome_referencia_estoque: '',
      iniciou_inventario: false,
      pagina_atual: 'I',
      contagem_produtos: [],
      tipo_ordenacao_contagem: 'NOM',
      lancamentos_produtos: [],
      tipo_ordenacao_lancamentos: 'LAN',
      referencia_estoque_selecionada: {},
      beep_som_sucesso: true,

      /* ############################### Parâmetros ############################### */
      par_utiliza_balanca: 'N',
      empresa_utiliza_wms: '',

      /* ############################### Autorizações ############################### */
      aut_lancar_inventario_total: 'N',
      aut_lancar_recontagem_total: 'N',
      aut_lancar_inventario_parcial: 'N',
      aut_lancar_recontagem_parcial: 'N',

      /* ############################### PAGINAÇÃO  ############################### */
      paginaAtual: 0,
      itensPorPagina: 10,
      totalResultados: 0,
      totalDePaginas: 0,

      /* ############################### Atributos da seleção de lote ############################### */
      produto_definicao_lote: '',
      lote_digitado: '',
      tonalidade_digitada: '',
      bitola_digitada: '',
      data_fabricacao_digitada: '',
      data_validade_digitada: '',
      nome_produto_buscar_lote: '',
      tipo_controle_estoque_lote: '', 
      coletar_lote: true,  
      tamanho_maximo_campo_lote: 20,  
      coletar_tonalidade: false,
      coletar_bitola: false,
      coletar_data_fabricacao: false,
      coletar_validade: false,
      lotes_item_selecionado: [],


      /* ############################### Atributos da pesquisa de referências de estoque ############################### */
      pesq_ref_local_id: 0,
      pesq_ref_opcao_filtro: 0,

      pesq_ref_titulo_filtro: undefined,
      pesq_ref_filtro_digitado: '',

      pesq_ref_referencias_estoque_filtradas: [],

      pesq_ref_tipos_pesquisa: {
        0: {
          indice_tela: 0,
          tipo: "NOM",
          descricao_pesquisa: "Nome ref. estoque",
          titulo: "Nome da referência de estoque"
        },

        1: {
          indice_tela: 1,
          tipo: "LOC",
          descricao_pesquisa: "Nome do local",
          titulo: "Nome do local"
        },

        2: {
          indice_tela: 2,
          tipo: "COD",
          descricao_pesquisa: "Numero ref. estoque",
          titulo: "Numero ref. estoque"
        },
      },

      pesq_ref_tipos_pesquisa_wms: {
        0: {
          indice_tela: 0,
          tipo: "DES",
          descricao_pesquisa: "Descrição",
          titulo: "Descrição do endereço"
        },
      },

      /* ############################### Atributos da pesquisa de produtos ############################### */
      pesq_pro_filtro_somente_ativos: true,
      pesq_pro_filtro_somente_pais: false,
      pesq_pro_filtro_somente_adicionais_manifesto: false,
      pesq_pro_filtro_trazer_kit: false,
      pesq_pro_filtro_somente_revenda: true,
      pesq_pro_filtro_somente_uso_consumo: false,
      pesq_pro_filtro_empresa_id_estoque_origem: 0,
      pesq_pro_filtro_empresa_id_estoque_destino: 0,
      pesq_pro_filtro_nome_resumido_estoque_origem: '',
      pesq_pro_filtro_nome_resumido_estoque_destino: '',
      pesq_pro_filtro_permitir_brinde_profissional: false,
      pesq_pro_filtro_somente_cesta_basica: false,
      realizando_leitura_codigo_barras: false,

      pesq_pro_processando: false,
      pesq_pro_mostrar_filtros: true,
      pesq_pro_spin: false,

      pesq_pro_opcao_filtro: 2,
      pesq_pro_tem_filtro_2: undefined,
      pesq_pro_filtro_1_inteiro: undefined,

      pesq_pro_titulo_filtro_1: undefined,
      pesq_pro_filtro_digitado_1: '',
      pesq_pro_tipo_campo_1: undefined,
      pesq_pro_texto_placeholder_1: undefined,
      pesq_pro_tamanho_maximo_1: undefined,

      pesq_pro_titulo_filtro_2: undefined,
      pesq_pro_filtro_digitado_2: '',
      pesq_pro_texto_placeholder_2: undefined,

      pesq_pro_produtos_filtrados: [],

      abrirModalLeitorCodigoBarras: false,

      pesq_pro_tipos_pesquisa: {
        0: {
            indice_tela: 0,
            tipo: "COD",
            descricao_pesquisa: "Código do produto",
            quantidade_campos: 1,
            titulo_1: "Código do produto",
            placeholder_1: "Digite apenas números",
            tipo_filtro_1: "I",
            tamanho_maximo_1: "10"
        },
        1: {
          indice_tela: 1,
          tipo: "NOM",
          descricao_pesquisa: "Nome do produto",
          quantidade_campos: 1,
          titulo_1: "Nome do produto",
          placeholder_1: "Informe pelo menos 2 caracteres",
          tipo_filtro_1: "S",
          tamanho_maximo_1: "50"
        },
        2: {
          indice_tela: 2,
          tipo: "BAR",
          descricao_pesquisa: "Código de barras",
          quantidade_campos: 1,
          titulo_1: "Código de barras",
          placeholder_1: "Apenas números",
          tipo_filtro_1: "I",
          tamanho_maximo_1: "14"
        },
        3: {
          indice_tela: 3,
          tipo: "ORI",
          descricao_pesquisa: "Código original",
          quantidade_campos: 1,
          titulo_1: "Código original",
          placeholder_1: "Código original de fábrica",
          tipo_filtro_1: "S",
          tamanho_maximo_1: "35"
        },
        4: {
          indice_tela: 4,
          tipo: "NOA",
          descricao_pesquisa: "Nome produto (av.)",
          quantidade_campos: 1,
          titulo_1: "Nome do produto (avançada)",
          placeholder_1: "Pelo menos 2 caracteres",
          tipo_filtro_1: "S",
          tamanho_maximo_1: "50"
        },
        5: {
          indice_tela: 5,
          tipo: "CUL",
          descricao_pesquisa: "Desc. cultura",
          quantidade_campos: 1,
          titulo_1: "Descrição da cultura",
          placeholder_1: "Pelo menos 2 caracteres",
          tipo_filtro_1: "S",
          tamanho_maximo_1: "50"
        },
        6: {
          indice_tela: 6,
          tipo: "NSI",
          descricao_pesquisa: "Nome prod.(similares)",
          quantidade_campos: 1,
          titulo_1: "Nome do produto (apenas similares)",
          placeholder_1: "Pelo menos 2 caracteres",
          tipo_filtro_1: "S",
          tamanho_maximo_1: "50"
        },
        7: {
          indice_tela: 7,
          tipo: "NMA",
          descricao_pesquisa: "Nome/marca (av.)",
          quantidade_campos: 2,
          titulo_1: "Nome (avançada)",
          placeholder_1: "Pelo menos 2 caracteres",
          tipo_filtro_1: "S",
          tamanho_maximo_1: "50",
          /* Atributos do segundo campo ------- */
          titulo_2: "Marca (avançada)",
          placeholder_2: "Pelo menos 2 caracteres",
          tamanho_maximo_2: "30"
        },
        8: {
          indice_tela: 8,
          tipo: "MAA",
          descricao_pesquisa: "Marca (avançada)",
          quantidade_campos: 1,
          titulo_1: "Marca (avançada)",
          placeholder_1: "Pelo menos 2 caracteres",
          tipo_filtro_1: "S",
          tamanho_maximo_1: "30"
        }
      }
    }
  },
  computed: {
    /* PAGINAÇÃO */
    referenciaEstoqueFiltrados() {
      this.totalResultados = this.pesq_ref_referencias_estoque_filtradas.length;
      this.totalDePaginas = Math.ceil(this.totalResultados / this.itensPorPagina);
      if (this.paginaAtual >= this.totalDePaginas) {
        this.paginaAtual = this.totalDePaginas;
      }
      var index = this.paginaAtual * this.itensPorPagina;
      return this.pesq_ref_referencias_estoque_filtradas.slice(index, index + this.itensPorPagina);
    },
    buscarItensLancamentoOrdenados(){
      let provisorio = Object.assign([], this.lancamentos_produtos);
      this.lancamentos_produtos = [];

      if (this.tipo_ordenacao_lancamentos == 'LAN') {
        provisorio.sort(this.ordenarPorLancamentoId);
      } else if (this.tipo_ordenacao_lancamentos == 'COD') {
        provisorio.sort(this.ordenarPorProdutoId);
      } else if (this.tipo_ordenacao_lancamentos == 'NOM') {
        provisorio.sort(this.ordenarPorNome);
      } else {
        alertar('Tipo de ordenação indefinido!');
      }

      this.lancamentos_produtos = provisorio;
      return this.lancamentos_produtos;
    },
    buscarItensInventarioOrdenados() {
      let provisorio = Object.assign([], this.contagem_produtos);
      this.contagem_produtos = [];

      if (this.tipo_ordenacao_contagem == 'COD') {
        this.contagem_produtos = provisorio.sort(this.ordenarPorProdutoId);
      } else if (this.tipo_ordenacao_contagem == 'NOM') {
        this.contagem_produtos = provisorio.sort(this.ordenarPorNome);
      } else {
        alertar('Tipo de ordenação indefinido!');
      }
      return  this.contagem_produtos;
    },
  },
  async created() {
    await this.carregarDadosIniciaisTelaContagens();
    this.pesqProAtualizarDefinicaoFiltro();
    this.pesqRefAtualizarDefinicaoFiltro();
  },
  async mounted() {
    // Buscando os dados do local storage.
    let local = await JSON.parse(localStorage.getItem('localStorage'));

     if 
        ( 
          (local) &&
          (local.inventario_lancamentos_offline) && 
          (local.inventario_lancamentos_offline.tipo_inventario) &&
          (local.inventario_lancamentos_offline.tipo_levantamento) &&
          (local.inventario_lancamentos_offline.contagem_produtos) &&
          (local.inventario_lancamentos_offline.lancamentos_produtos) &&
          (local.inventario_lancamentos_offline.referencia_estoque_selecionada)
        ) 
      {
        await swal("Deseja retornar com o antigo lançamento de inventário?", {
          buttons: {            
            sim: "Sim",
            nao: "Não"
          },
          showLoaderOnConfirm: true
        })
        .then(async (value) => {
          switch (value) {
            case "nao":
              await this.limparLocalStorage();
              break;
            case "sim":
              await this.recarregarDadosLocalStorage();
              await this.iniciarInventario();
              this.pagina_atual = 'L';
              await this.pesqRefOcultar();
              Biblioteca.informar("Inventário carregado com sucesso.");
              break;
          }
        });
      }
  },  
  methods: {
    /* PAGINAÇÃO */
    mudarPagina(numeroDaPagina) {
      this.paginaAtual = numeroDaPagina;
    },
    
    iniciarInventario() {
      if (this.tipo_inventario == '') {
        Biblioteca.exclamar('Selecione o tipo de inventário!');
        return;
      }

      if (this.tipo_levantamento == '') {
        Biblioteca.exclamar('Selecione o tipo de levantamento!');
        return;
      }

      if (this.referencia_estoque_selecionada.referencia_estoque_id == undefined) {
        Biblioteca.exclamar('Selecione a referência de estoque!');
        return;
      }

      this.iniciou_inventario = true;
    },
    
    formatarProdutoId(id) {
      return nPadrao(id, 0);
    },
    
    temControleLote(tipo_controle_lote) {
      let vetor = ['L', 'P', 'G', 'T'];
      return (vetor.indexOf(tipo_controle_lote) >= 0);
    },

    temControleLoteComPiso(tipo_controle_lote) {
      return Biblioteca.em(tipo_controle_lote, ['P', 'T']);   
    },
    
    buscarClasseEditProduto() {
      if (this.pesq_pro_tem_filtro_2) {
        return "w3-col l6 m12 s12";
      } else {
        return "w3-col l12 m12 s12";
      }
    },

    lancarProduto(){
      this.pagina_atual = 'I';
      this.quantidade_digitada_str = 1;
      this.$nextTick(() => this.$refs.campo_codigo_digitado.focus());
    },

    lerCodigoBarras() {
      this.abrirModalLeitorCodigoBarras = true;
      this.realizando_leitura_codigo_barras = true;
      this.pesq_pro_tipos_pesquisa[this.pesq_pro_opcao_filtro].tipo = 'BAR';
    },

    async buscarPeloCodigoBarras(codigo){
      if (!codigo)
        return;    
        
      let parametros = { 
        chave_pesquisa: codigo 
      };  

      let retorno = await RProdutoBuscarProdutoPorIdOuCodigoBarras.buscarProduto(this.axios, parametros);
      if (retorno.houve_erro == 'S'){
        await swal(retorno.mensagem);
        this.abrirModalLeitorCodigoBarras = true;
        return;
      }

      try {
        this.codigo_digitado = codigo;
        this.realizando_leitura_codigo_barras = true;
        await this.carregarProdutoLeitura();
        await this.fecharLeitorCodigoBarras();
      } finally {
        this.codigo_digitado = '';
        this.pesq_pro_spin = false;
        this.pesq_pro_processando = false;
        this.realizando_leitura_codigo_barras = false;
      }
    },

    frontEndDateFormat(date) {
      if (!date){
        return "";
      }

      return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },

    async armazenarLocalStorage(){
      let armazenamentoLocalStorage = await JSON.parse(localStorage.getItem('localStorage'));

      if (!armazenamentoLocalStorage){
        armazenamentoLocalStorage = {};
      }

      if (!armazenamentoLocalStorage.inventario_lancamentos_offline){
        armazenamentoLocalStorage.inventario_lancamentos_offline = {};
      }

      armazenamentoLocalStorage.inventario_lancamentos_offline.tipo_inventario = this.tipo_inventario;
      armazenamentoLocalStorage.inventario_lancamentos_offline.tipo_levantamento = this.tipo_levantamento;
      armazenamentoLocalStorage.inventario_lancamentos_offline.contagem_produtos = this.contagem_produtos;
      armazenamentoLocalStorage.inventario_lancamentos_offline.lancamentos_produtos = this.lancamentos_produtos;
      armazenamentoLocalStorage.inventario_lancamentos_offline.referencia_estoque_selecionada = this.referencia_estoque_selecionada;
      armazenamentoLocalStorage.inventario_lancamentos_offline.data_ultima_atualizacao = this.frontEndDateFormat(new Date());
      // Armazenando parâmetros no local storage
      await localStorage.setItem('localStorage', JSON.stringify(armazenamentoLocalStorage));
    },

    async limparLocalStorage(){
      let armazenamentoLocalStorage = await JSON.parse(localStorage.getItem('localStorage'));
      armazenamentoLocalStorage.inventario_lancamentos_offline = {};
      await localStorage.setItem('localStorage', JSON.stringify(armazenamentoLocalStorage));
    },  

    async recarregarDadosLocalStorage(){
      let local = await JSON.parse(localStorage.getItem('localStorage'));

      if (local.inventario_lancamentos_offline.contagem_produtos){
        this.contagem_produtos = await JSON.parse(JSON.stringify(local.inventario_lancamentos_offline.contagem_produtos));  
      }

      if (local.inventario_lancamentos_offline.lancamentos_produtos){
        this.lancamentos_produtos = await JSON.parse(JSON.stringify(local.inventario_lancamentos_offline.lancamentos_produtos));  
      }

      if (local.inventario_lancamentos_offline.tipo_inventario){
        this.tipo_inventario = await JSON.parse(JSON.stringify(local.inventario_lancamentos_offline.tipo_inventario));  
      }

      if (local.inventario_lancamentos_offline.tipo_levantamento){
        this.tipo_levantamento = await JSON.parse(JSON.stringify(local.inventario_lancamentos_offline.tipo_levantamento));  
      }

      if (local.inventario_lancamentos_offline.referencia_estoque_selecionada){
        this.referencia_estoque_selecionada = await JSON.parse(JSON.stringify(local.inventario_lancamentos_offline.referencia_estoque_selecionada));  
      }
    },

    async carregarProdutoLeitura() {
      if (this.realizando_leitura_codigo_barras){
        await this.insercaoDiretaProduto();
        this.realizando_leitura_codigo_barras = false;
        this.abrirModalLeitorCodigoBarras = false;
      }
    },
    
    fecharLeitorCodigoBarras() {
      this.abrirModalLeitorCodigoBarras = false;
      this.realizando_leitura_codigo_barras = false;
    },
    
    async insercaoDiretaProduto(){
      try {
        if ((this.codigo_digitado == '') || (this.codigo_digitado.trim() == '')) {
          this.alertar('Informe o código de barras ou código do produto!');
          this.resetInputCodigoBarras();
          return;
        }

        if (this.codigo_digitado != numeros(this.codigo_digitado)) {
          this.alertar('Informe um código de barras ou código de produto válido!');
          this.resetInputCodigoBarras();
          return;
        }

        if (Biblioteca.valor(this.quantidade_digitada_str) < 0) {
          this.quantidade_digitada_str = 1;
          this.alertar('A quantidade deve ser maior ou igual a 0!');
          this.resetInputCodigoBarras();
          return;
        }

        $('#campo_codigo_digitado').prop('disabled', true);
        $('#focus_input_aux').focus();

        this.pesq_pro_spin = true;
        this.produtos_filtrados = [];
        let parametros = { 
          chave_pesquisa: this.codigo_digitado 
        };       
      
        let retorno = await RProdutoBuscarProdutoPorIdOuCodigoBarras.buscarProduto(this.axios, parametros);
       
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        if (Biblioteca.valor(retorno.dados.quantidade_caixa_fechada) > 0){
          this.quantidade_digitada_str = Biblioteca.valor(this.quantidade_digitada_str) * Biblioteca.valor(retorno.dados.quantidade_caixa_fechada);
        }

        this.pesq_pro_processando = true;
        /* Verifico primeiro se o produto adicionado já está no vetor dentre os selecionados */
        for (let i = 0; i < this.contagem_produtos.length; i++) {
          let produto = Object.assign([], this.contagem_produtos[i]);

          if 
          (
            (
              (this.pesq_pro_tipos_pesquisa[this.pesq_pro_opcao_filtro].tipo == 'BAR') &&
              (this.contagem_produtos[i].codigo_barras == this.codigo_digitado)
            ) ||
            (
              (this.pesq_pro_tipos_pesquisa[this.pesq_pro_opcao_filtro].tipo == 'COD') &&
              (this.contagem_produtos[i].produto_id == retorno.dados.produto_id)
            )
          ) {
            if (this.temControleLote(produto.tipo_controle_estoque)) {
              this.coletarLote(produto);
            } else {
              this.efetivarLancamentoItem(produto, i, undefined, false);
            }

            vibrar();
            this.resetInputCodigoBarras();
            return;
          }
        }

        this.pesq_pro_opcao_filtro = (this.codigo_digitado == retorno.dados.produto_id) ? 0 : this.pesq_pro_opcao_filtro;

        if (this.pesq_pro_tipos_pesquisa[this.pesq_pro_opcao_filtro].tipo == 'BAR'){
          await this.buscarProdutos(this.pesq_pro_tipos_pesquisa[this.pesq_pro_opcao_filtro].tipo, this.codigo_digitado, '', false);
        }

        if (this.pesq_pro_tipos_pesquisa[this.pesq_pro_opcao_filtro].tipo == 'COD') {
          await this.buscarProdutos(this.pesq_pro_tipos_pesquisa[this.pesq_pro_opcao_filtro].tipo, retorno.dados.produto_id, '', false);
        }

        this.pesq_pro_processando = false;
        this.pesq_pro_spin = false;
      } catch (error) {
        this.pesq_pro_processando = false;
        this.alertar(error.message);
        vibrar();
        this.resetInputCodigoBarras();
      }

      vibrar();
      this.resetInputCodigoBarras();
    },
    
    resetInputCodigoBarras() {
      const campo_codigo_digitado = $('#campo_codigo_digitado')
      campo_codigo_digitado.prop('disabled', false);
      this.$nextTick(() => this.$refs.campo_codigo_digitado.focus());

      this.codigo_digitado = '';
      this.pesq_pro_spin = false;
      this.pesq_pro_processando = false;
    },
    
    focusCampoCodigoBarra() {
      if (this.pagina_atual == 'I'){
        this.$nextTick(() => this.$refs.campo_codigo_digitado.focus());
      }
    },
    
    async buscarProdutos(tipo_pesquisa, chave_pesquisa_1, chave_pesquisa_2, edicao_conferencia, dados_lote = {}){
      try {
        let parametros = { 
          tipo_pesquisa: tipo_pesquisa,
          chave_pesquisa_1: chave_pesquisa_1,
          chave_pesquisa_2: chave_pesquisa_2,
          filtro_somente_ativos: 'S',
          filtro_pesquisa_compra: 'N',
          filtro_somente_pais: 'N',
          filtro_trazer_kit: 'N',
          filtro_somente_revenda: 'S',
          filtro_somente_uso_consumo: 'N',
          filtro_somente_brinde_profissional: 'N',
          filtro_somente_ativos_imobilizados: 'N',
          filtro_somente_servicos: 'N',
          filtro_somente_cesta_basica: 'N'
        };

        let retorno = await RProdutoBuscarProdutoPesquisa.buscarProdutosPesquisa(this.axios, parametros);
        
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }
        
        this.codigo_digitado = '';
        let produto = retorno.dados[0];

        if (this.temControleLote(produto.tipo_controle_estoque) && !edicao_conferencia) {
          this.coletarLote(produto);
        } else {
          if (produto.tipo_controle_estoque === 'P' && edicao_conferencia) {
            const [bitola, tonalidade] = dados_lote.lote.split('-');
            dados_lote.tonalidade = tonalidade;
            dados_lote.bitola = bitola;
          } else if (produto.tipo_controle_estoque === 'T' && edicao_conferencia) {
            const [bitola, lote_tmp] = dados_lote.lote.split('-');
            const[tonalidade, lote] = lote_tmp.split('|');
            dados_lote.tonalidade = tonalidade;
            dados_lote.bitola = bitola;
            dados_lote.lote = lote;
          }

          this.efetivarLancamentoItem(produto, undefined, dados_lote, edicao_conferencia);
        }
      } catch (error) {

        let retorno = error.resposta? error.resposta.data.dados.codigo_erro + ": " + error.response.data.dados.mensagem_erro: error.message;        
        this.alertar(retorno);
      }
    
    },
    
    async gravarContagem(){
      try {
        let itens_inventario = [];

        for (let i = 0; i < this.contagem_produtos.length; i++) {
          if (this.temControleLote(this.contagem_produtos[i].tipo_controle_estoque)) {
            for (let j = 0; j < this.contagem_produtos[i].dados_lotes.length; j++) {
              const dados_lote = this.contagem_produtos[i].dados_lotes[j];  
              
              var lote_tmp = '';
              if (this.temControleLoteComPiso(this.contagem_produtos[i].tipo_controle_estoque)) {
                lote_tmp = `${dados_lote.bitola}-${dados_lote.tonalidade}`;

                if (this.contagem_produtos[i].tipo_controle_estoque == 'T'){
                  lote_tmp +=  `|${dados_lote.lote.trim()}`;
                }
              } else {
                lote_tmp =  `${dados_lote.lote}`;
              }

              let item = {
                produto_id: this.contagem_produtos[i].produto_id,
                produto_ref: this.contagem_produtos[i].produto_ref,
                quantidade: this.formatarValor(dados_lote.quantidade),
                tipo_controle_estoque: this.contagem_produtos[i].tipo_controle_estoque,
                lote: lote_tmp,
                data_fabricacao: dados_lote.data_fabricacao ? dados_lote.data_fabricacao : '',
                data_validade: dados_lote.vencimento ? dados_lote.vencimento : '',
                endereco_wms_id: 0
              };

              itens_inventario.push(item);
            }
          } else {
            let item = {
              produto_id: this.contagem_produtos[i].produto_id,
              produto_ref: this.contagem_produtos[i].produto_ref,
              quantidade: this.formatarValor(this.contagem_produtos[i].quantidade, 3),
              tipo_controle_estoque: this.contagem_produtos[i].tipo_controle_estoque,
              endereco_wms_id: 0,
              lote: '?'
            };

            itens_inventario.push(item);
          }
        }
        
        let parametros = {
          tipo_inventario: this.tipo_inventario,
          tipo_levantamento: this.tipo_levantamento,
          referencia_estoque_id: this.referencia_estoque_selecionada.referencia_estoque_id,
          local_id: this.referencia_estoque_selecionada.local_id,
          itens: itens_inventario
        }

        let retorno = await RInventario.atualizarContagem(this.axios, parametros);
        
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem); 
        }

        await this.limparLocalStorage();
      
        swal({
          title: retorno.dados.mensagem,
          icon: "success",
          button: {
            confirm: {
              text: "OK",
              value: true,
              visible: true,
              closeModal: true,
            },
          },
        }).then((value) => {
          window.location.reload();
        });
      } catch (e) {
        Biblioteca.exclamar(e.message);
      }
    },
    
    efetivarLancamentoItem(produto, indice_inventario, dados_lote, carregar_inventario) {
      let produto_lancamento = Object.assign({}, {
        ...produto,
        ...dados_lote,
        data_fabricacao: dados_lote && carregar_inventario ? dados_lote.data_fabricacao : this.data_fabricacao_digitada,
        vencimento: dados_lote && carregar_inventario ? dados_lote.vencimento.trim() : this.data_validade_digitada,
        quantidade: dados_lote && carregar_inventario ? parseFloat(dados_lote.quantidade) : parseFloat(this.quantidade_digitada_str),
        // lote: dados_lote && this.temControleLote(produto.tipo_controle_estoque) ? dados_lote.lote :  this.lote_digitado,
        lancamento_id: this.lancamentos_produtos.length + 1,
        mostrar_detalhes: false,
        mostrar_lotes: false
      });

      if (indice_inventario == undefined) {
        indice_inventario = this.buscarIndiceInventarioSelecionado(produto.produto_id);
      }

      /* Produto adicionado a primeira vez no inventário */
      if (indice_inventario == -1) {
        let produto_inventario = Object.assign({}, {
          ...produto_lancamento,
          dados_lotes: [],
        });

        /* Adicionando totalização agrupada por lote no inventário */
        if (this.temControleLote(produto_lancamento.tipo_controle_estoque)) {
          dados_lote.quantidade = produto_inventario.quantidade;
          produto_inventario.dados_lotes.push(dados_lote);
        }

        this.contagem_produtos.push(produto_inventario);
        this.lancamentos_produtos.push(produto_lancamento);
        this.quantidade_digitada_str = 1;
        this.leituraPoket(carregar_inventario);
      } else {
        if (this.temControleLote(produto_lancamento.tipo_controle_estoque)) {
          const indice_lote = this.buscarIndiceLote(this.contagem_produtos[indice_inventario], dados_lote);
          this.lancamentos_produtos.push(produto_lancamento);

          /* Adicionando item com novo lote no inventário */
          if (indice_lote == -1) {
            dados_lote.quantidade = carregar_inventario ? parseInt(dados_lote.quantidade) : parseInt(this.quantidade_digitada_str);

            // Incrementa a quantidade do produto
            this.contagem_produtos[indice_inventario].quantidade += dados_lote.quantidade;
            this.contagem_produtos[indice_inventario].dados_lotes.push(dados_lote);

            this.quantidade_digitada_str = 1;
            this.leituraPoket(carregar_inventario);
          } else {
            this.contagem_produtos[indice_inventario].dados_lotes[indice_lote].quantidade += parseInt(this.quantidade_digitada_str);
            this.contagem_produtos[indice_inventario].dados_lotes[indice_lote].vencimento = this.data_validade_digitada;
            this.contagem_produtos[indice_inventario].dados_lotes[indice_lote].data_fabricacao = this.data_fabricacao_digitada;

            // Totalizador Produtos
            this.contagem_produtos[indice_inventario].quantidade = 0;
            this.contagem_produtos[indice_inventario].dados_lotes.forEach((contagem, index) => {
              this.contagem_produtos[indice_inventario].quantidade += contagem.quantidade;
            });
            this.leituraPoket(carregar_inventario);
            this.quantidade_digitada_str = 1;
          }
        } else {
          const indice_contagem = this.contagem_produtos.findIndex(lancamento => {
            if (lancamento.produto_id === produto_lancamento.produto_id)  return lancamento.produto_id
          })

          this.contagem_produtos[indice_contagem].quantidade += parseInt(this.quantidade_digitada_str);
          this.lancamentos_produtos.push(produto_lancamento);
          this.quantidade_digitada_str = 1;
          this.leituraPoket(carregar_inventario);
        }
      }

      this.armazenarLocalStorage();
    },
    
    leituraPoket(carregar_inventario) {
      if (!carregar_inventario)  {
        Biblioteca.informar('Item lançado!')

        if (this.beep_som_sucesso) {
          console.log(this.beep_som_sucesso);
          const audio = document.querySelector('audio#leitura-poket');
          console.log(this.beep_som_sucesso);
          if (!audio)  return;
          audio.currentTime = 0;
          audio.play();
        }
      }
    },
    
    buscarIndiceLancamentoSelecionado(lancamento_id) {
      for (let i = 0; i < this.lancamentos_produtos.length; i++) {
        if (this.lancamentos_produtos[i].lancamento_id == lancamento_id) {
          return i;
        }
      }
      return -1;
    },
    
    buscarIndiceLote(contagem_produto, dados_lote) {
      for (let i = 0; i < contagem_produto.dados_lotes.length; i++) {
         if (contagem_produto.tipo_controle_estoque == 'P') {
           
           if (
                (contagem_produto.dados_lotes[i].bitola == dados_lote.bitola) && 
                (contagem_produto.dados_lotes[i].tonalidade == dados_lote.tonalidade)
              ) {
             return i;       
           }

         } else if (contagem_produto.tipo_controle_estoque == 'T') {
           
           if (
                 (contagem_produto.dados_lotes[i].bitola == dados_lote.bitola) && 
                 (contagem_produto.dados_lotes[i].tonalidade == dados_lote.tonalidade) &&
                 (contagem_produto.dados_lotes[i].lote == dados_lote.lote)) {
              return i;       
            } 

         } else if (contagem_produto.dados_lotes[i].lote == dados_lote.lote) {
           return i;
         }       
      }
      return -1;
    },
    
    alertar(mensagem) {
      /* Mensagem */
      Biblioteca.exclamar(mensagem);

      /* Vibração do celular */
      vibrar();

      /* Aviso sonoro */
      const audio =  document.querySelector('#alerta-poket')
      if (!audio)  return;
      audio.currentTime = 0;
      audio.play();
    },
    
    alternarDetalhesContagem(produto_id){
      let indice = this.buscarIndiceInventarioSelecionado(produto_id);
      if (indice == -1) return;

      this.contagem_produtos[indice].mostrar_detalhes = !this.contagem_produtos[indice].mostrar_detalhes;
    },
    
    alternarLotes(produto_id){
      let indice = this.buscarIndiceInventarioSelecionado(produto_id);
      if (indice == -1) return;

      this.contagem_produtos[indice].mostrar_lotes = !this.contagem_produtos[indice].mostrar_lotes;
    },
    
    alternarDetalhesLancamento(lancamento_id){
      let indice = this.buscarIndiceLancamentoSelecionado(lancamento_id);
      if (indice == -1) return;

      this.lancamentos_produtos[indice].mostrar_detalhes = !this.lancamentos_produtos[indice].mostrar_detalhes;
    },
    
    coletarLote(produto){
      if (!this.temControleLote(produto.tipo_controle_estoque)) return;

      this.produto_definicao_lote = Object.assign({}, produto);

      this.nome_produto_buscar_lote = nPadrao(produto.produto_id, 0) + ' - ' + produto.nome;

      this.coletar_data_fabricacao = (produto.exigir_data_fabricacao == 'S');
      this.coletar_validade = (produto.exigir_validade == 'S');
      this.tipo_controle_estoque_lote = produto.tipo_controle_estoque;

      if (this.temControleLoteComPiso(produto.tipo_controle_estoque)) {
        this.coletar_tonalidade = true; 
        this.coletar_bitola = true;                 
      } else {
        this.coletar_tonalidade = false; 
        this.coletar_bitola = false;        
      }

      if (produto.tipo_controle_estoque == 'T')
          this.tamanho_maximo_campo_lote = 16
      else
        this.tamanho_maximo_campo_lote = 20;      
           
      this.coletar_lote = (produto.tipo_controle_estoque != 'P');      
      
      this.buscarLoteMostrar();
    },
    
    definirLoteManual(){                      
      if (this.coletar_bitola) {
        this.bitola_digitada = this.bitola_digitada.trim();
        if (this.bitola_digitada == '') {
          this.alertar('Informe a bitola!');
          $('#campo_bitola').focus();
          return;
        }
      }

      if (this.coletar_tonalidade) {
        this.tonalidade_digitada = this.tonalidade_digitada.trim();
        if (this.tonalidade_digitada == '') {
          this.alertar('Informe a tonalidade!');
          $('#campo_tonalidade').focus();
          return;
        }
      } 
      
      if (this.coletar_lote) {
        this.lote_digitado = this.lote_digitado.trim();

        if (this.lote_digitado == '') {          
          this.alertar('Informe o lote!');
          $('#campo_lote').focus();
          return;
        }      
      }

      if (this.coletar_bitola && this.coletar_tonalidade && this.coletar_lote){
        if  ((this.bitola_digitada.length + this.tonalidade_digitada.length + this.lote_digitado.length) > 20){
          this.alertar('A soma dos caracteres da bitola, tonalidade e lote não pode ser superior a 20!');
          $('#campo_bitola').focus();
          return;
        }
      }

     


      if (this.coletar_data_fabricacao) {
        if (!dataOk(this.data_fabricacao_digitada)) {
          this.alertar('Data de fabricação inválida!');
          $('#campo_data_fabricacao').focus();
          return;
        }
      }

      if (this.coletar_validade) {
        if (!dataOk(this.data_validade_digitada)) {
          this.alertar('Data de validade inválida!');
          $('#campo_data_validade').focus();
          return;
        }
      }

      if (this.coletar_data_fabricacao && this.coletar_validade) {
        let data_fabricacao = toDate(this.data_fabricacao_digitada);
        let data_validade = toDate(this.data_validade_digitada);

        if (data_fabricacao >= data_validade) {
          this.alertar('A data de fabricação não pode ser maior ou igual a data de vencimento!');
          $('#campo_data_fabricacao').focus();
          return;
        }
      }

      let dados_lote = {        
        bitola: this.bitola_digitada.toUpperCase(),
        tonalidade: this.tonalidade_digitada.toUpperCase(),
        lote: this.lote_digitado.toUpperCase(),
        data_fabricacao: this.data_fabricacao_digitada,
        vencimento: this.data_validade_digitada,
      };

      this.efetivarLancamentoItem(this.produto_definicao_lote, null, dados_lote, false);
      this.buscarLoteOcultar();
      this.focusCampoCodigoBarra();
    },
    
    excluirLancamento(lancamento) {
      swal('Tem certeza que deseja excluir o lançamento?', {
        buttons: {
          sim: "Sim",
          nao: "Não",
        },
      })
      .then((value) => {
        switch (value) {
          case "nao":
            return false;
            break;
          case "sim":
            let indice_lancamento = this.buscarIndiceLancamentoSelecionado(lancamento.lancamento_id);
            if (indice_lancamento <= -1) {
              alertar('Não foi possível localizar o índice do lançamento');
            }

            let indice_contagem = this.buscarIndiceInventarioSelecionado(lancamento.produto_id);
            if (indice_contagem <= -1) {
              alertar('Não foi possível localizar o índice do item de inventário');
            }

            /* Removendo o elmento da contagem */
            this.lancamentos_produtos.splice(indice_lancamento, 1);

            /* Ajustando o índice do lançamento */
            for (let i = 0; i < this.lancamentos_produtos.length; i++) {
              if (this.lancamentos_produtos[i].lancamento_id > lancamento.lancamento_id) {
                this.lancamentos_produtos[i].lancamento_id -= 1;
              }
            }

            /* Deduzindo a quantidade do lançamento no inventário */
            this.contagem_produtos[indice_contagem].quantidade -= lancamento.quantidade;

            /* Removendo o elemento do vetor caso a quantidade tenha zerado - não faz mais parte do inventário              */
            /* Não remover o nPadrao. No javascript, assim como outras linguagens, tem problema ao comparar ponto flutuante */
            if (nPadrao(this.contagem_produtos[indice_contagem].quantidade, 3) == nPadrao(0, 3)) {
              this.contagem_produtos.splice(indice_contagem, 1);
            } else if (this.temControleLote(this.contagem_produtos[indice_contagem].tipo_controle_estoque)) {
              const dados_lote = {
                lote: lancamento.lote,
                tonalidade: lancamento.tonalidade,
                bitola: lancamento.bitola
              }

              let indice_lote = this.buscarIndiceLote(this.contagem_produtos[indice_contagem], dados_lote);
              this.contagem_produtos[indice_contagem].dados_lotes[indice_lote].quantidade -= lancamento.quantidade;
              if (nPadrao(this.contagem_produtos[indice_contagem].dados_lotes[indice_lote].quantidade, 3) == nPadrao(0, 3)) {
                this.contagem_produtos[indice_contagem].dados_lotes.splice(indice_lote, 1);
              }
            }

            this.armazenarLocalStorage();
            break;
        }
      });
    },
    
    ordenarPorProdutoId(obj1, obj2) {
      return parseInt(obj1.produto_id) < parseInt(obj2.produto_id) ? -1 : parseInt(obj1.produto_id) > parseInt(obj2.produto_id) ? 1 : 0;
    },
    
    ordenarPorLancamentoId(obj1, obj2) {
      /* Ordem decrescente */
      return parseInt(obj2.lancamento_id) < parseInt(obj1.lancamento_id) ? -1 : parseInt(obj2.lancamento_id) > parseInt(obj1.lancamento_id) ? 1 : 0;
    },
    
    ordenarPorNome(obj1, obj2) {
      return obj1.nome < obj2.nome ? -1 : obj1.nome > obj2.nome ? 1 : 0;
    },
    
    buscarClasseOrdenacaoContagem(tipo_ord) {
      if (this.tipo_ordenacao_contagem == tipo_ord) {
        return 'w3-button w3-theme';
      } else {
        return 'w3-button w3-theme-l6';
      }
    },
    
    buscarClasseOrdenacaoLancamentos(tipo_ord) {
      if (this.tipo_ordenacao_lancamentos == tipo_ord) {
        return 'w3-button w3-theme';
      } else {
        return 'w3-button w3-theme-l6';
      }
    },
    
    async carregarDadosIniciaisTelaContagens() {
      try {
        let retorno = await RInventario.buscarDadosIniciaisTelaContagens(this.axios);
        
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }
        
        let resultado = retorno.dados;

        if (resultado.msg != undefined){
          this.alertar(resultado.msg);
        } else {
          /* Parâmetros */
          this.par_utiliza_balanca = resultado.par_utiliza_balanca;
          this.empresa_utiliza_wms = resultado.par_tipo_controle_wms;

          /* Autorizações */
          this.aut_lancar_inventario_total = resultado.aut_lancar_inventario_total;
          this.aut_lancar_recontagem_total = resultado.aut_lancar_recontagem_total;
          this.aut_lancar_inventario_parcial = resultado.aut_lancar_inventario_parcial;
          this.aut_lancar_recontagem_parcial = resultado.aut_lancar_recontagem_parcial;
        }
      } catch (e) {
        Biblioteca.exclamar(e.message);
      }
    },
    
    /* ############################### Métodos do modal de coleta de lotes ############################### */
    buscarLoteMostrar() {  
      var that = this;       
      $('#buscarLoteModal').removeAttr("style").show(10, () => {
           if (that.coletar_bitola) {
             that.$nextTick(() => that.$refs.campo_bitola.focus());
           } else if (that.coletar_lote) {
              that.$nextTick(() => that.$refs.campo_lote.focus());
           }
        }       
      );       
    },
    
    buscarLoteOcultar() {
      $('#buscarLoteModal').removeAttr("style").hide();

      this.lote_digitado = '';
      this.tonalidade_digitada = '';
      this.bitola_digitada = '';
      this.data_fabricacao_digitada = '';
      this.data_validade_digitada = '';
    },
    
    /* ############################### Métodos do modal de referências de estoque ############################### */
    pesqRefMostrar() {
      if (this.tipo_inventario == '') {
        Biblioteca.exclamar('Selecione o tipo de inventário!');
        return;
      }

      if (this.tipo_levantamento == '') {
        Biblioteca.exclamar('Selecione o tipo de levantamento!');
        return;
      }

      this.pesqRefAtualizarDefinicaoFiltro();
      $('#pesqRefModal').show();
      $('#pesq_ref_filtro').focus()
    },
    
    pesqRefOcultar() {
      $('#pesqRefModal').hide();
    },
    
    async pesqRefSelecionar(objeto, buscarProdutos) {    
      try {
        this.pesq_pro_processando = true
        this.referencia_estoque_selecionada = Object.assign({}, objeto);
        this.nome_referencia_estoque = nPadrao(this.referencia_estoque_selecionada.referencia_estoque_id, 0) + ' - ' + this.referencia_estoque_selecionada.nome;

        let parametros = {
          referencia_endereco_wms_id: objeto.referencia_estoque_id,
          tipo_inventario: this.tipo_inventario,
          tipo_levantamento: this.tipo_levantamento
        }
      
        let retorno = await RInventario.buscarInventarioEdicao(this.axios, parametros);
        
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        // Buscar produtos para edição
        let produtos_edicao = retorno.dados;

        for (let i = 0; i < produtos_edicao.length; i++){
          await this.buscarProdutos('COD', produtos_edicao[i].produto_id, '', true, produtos_edicao[i]);
        }

        this.iniciarInventario();
        this.pagina_atual = 'L';
        this.pesq_pro_processando = false;
        this.pesqRefOcultar();
      } catch (e) {
        this.pesq_pro_processando = false;
        this.pesqRefOcultar();
        Biblioteca.exclamar(e.message);
      }
    },
    
    pesqRefFormatarReferencia(id) {
      return nPadrao(id, 0);
    },
    
    pesqRefAtualizarDefinicaoFiltro() {
      this.pesq_ref_titulo_filtro = this.pesq_ref_tipos_pesquisa[this.pesq_ref_opcao_filtro].titulo;
    },
    
    async pesqRefPesquisar(){
      try {
        this.pesq_ref_referencias_estoque_filtradas = [];
        let parametrosPesquisa;

        if (this.empresa_utiliza_wms != "S") {
          if (this.pesq_ref_opcao_filtro == 0) {
            parametrosPesquisa = {
              tipo_pesquisa: this.pesq_ref_tipos_pesquisa[0].tipo,
              chave_pesquisa: this.pesq_ref_filtro_digitado.toUpperCase(),
              filtro_local_id: this.pesq_ref_local_id
            };
          } else if (this.pesq_ref_opcao_filtro == 1) {
            this.pesq_ref_filtro_digitado = this.pesq_ref_filtro_digitado.replace('.', "");
            parametrosPesquisa = {
              tipo_pesquisa: this.pesq_ref_tipos_pesquisa[1].tipo,
              chave_pesquisa: this.pesq_ref_filtro_digitado.toUpperCase(),
              filtro_local_id: this.pesq_ref_local_id
            };
          } else if (this.pesq_ref_opcao_filtro == 2) {
            parametrosPesquisa = {
              tipo_pesquisa: this.pesq_ref_tipos_pesquisa[2].tipo,
              chave_pesquisa: this.pesq_ref_filtro_digitado.toUpperCase(),
              filtro_local_id: this.pesq_ref_local_id
            };
          }
        } else {
          parametrosPesquisa = {
            tipo_pesquisa: this.pesq_ref_tipos_pesquisa_wms[0].tipo,
            chave_pesquisa: this.pesq_ref_filtro_digitado.toUpperCase(),
            filtro_local_id: this.pesq_ref_local_id
          };
        }

        this.pesq_pro_processando = true;
        let retorno = await RInventario.buscarReferenciaEstoquePesquisa(this.axios, parametrosPesquisa);
        
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        this.pesq_ref_referencias_estoque_filtradas = Object.assign([], retorno.dados);
        this.pesq_pro_processando = false;
      } catch (e) {
        this.pesq_pro_processando = false;
        Biblioteca.exclamar(e.message);
      }
    },
    
    pesqRefDefinirPesquisa(indice) {
      this.pesq_ref_opcao_filtro = indice;
      this.pesqRefAtualizarDefinicaoFiltro();
    },
    
    /* ############################### Métodos do modal de produtos ############################### */
    buscarClasseProdutoSelecionado(produto_id, large) {
      let classes;

      if (this.buscarIndiceInventarioSelecionado(produto_id) > -1) {
        return classes + "w3-theme ";
      } else {
        return classes + "w3-white ";
      }
    },
    
    async pesqProSelecionarProduto(produto) {
      this.codigo_digitado = produto.produto_id;
      await this.buscarProdutos('COD', produto.produto_id, '', false);
      this.pesqProOcultar();
    },
    
    teclaEnterLote(campo) {
      if (campo == 'campo_bitola') {
        if (this.coletar_tonalidade) {
           $('#campo_tonalidade').focus();
        } else if (this.coletar_lote) {
          $('#campo_lote').focus();
        } else if (this.coletar_data_fabricacao) {
          $('#campo_data_fabricacao').focus();
        } else if (this.coletar_validade) {
          $('#campo_data_validade').focus();
        } else {
          this.definirLoteManual();
        }
      }

      if (campo == 'campo_tonalidade') {
        if (this.coletar_lote) {
          $('#campo_lote').focus();
        } else if (this.coletar_data_fabricacao) {
          $('#campo_data_fabricacao').focus();
        } else if (this.coletar_validade) {
          $('#campo_data_validade').focus();
        } else {
          this.definirLoteManual();
        }
      }

      if (campo == 'campo_lote') {
        if (this.coletar_data_fabricacao) {
          $('#campo_coletar_data_fabricacao').focus();
        } else if (this.coletar_validade) {
          $('#campo_data_validade').focus();
        } else {
          this.definirLoteManual();
        }
      }
      
      if (campo == 'campo_data_fabricacao') {
        if (this.coletar_validade) {
          $('#campo_coletar_validade').focus();        
        } else {
          this.definirLoteManual();
        }
      }

      if (campo == 'campo_data_validade') {
        this.definirLoteManual();
      }
    },
    
    buscarIndiceInventarioSelecionado(produto_id) {
      for (let i = 0; i < this.contagem_produtos.length; i++) {
        if (this.contagem_produtos[i].produto_id == produto_id) {
          return i;
        }
      }
      return -1;
    },
    
    pesqProMostrar() {
      this.pesqProAtualizarDefinicaoFiltro();
      $('#pesqProModal').toggle(100);
    },
    
    pesqProOcultar() {
      $('#pesqProModal').removeAttr("style").hide();
    },
    
    async pesqProTeclarEnterFiltro1() {
      if (this.tem_filtro_2) {
        $('#pesq_pro_filtro_2').focus();
      } else {
        await this.pesqProPesquisar();
      }
    },
    
    pesqProAlternarFiltros() {
      this.pesq_pro_mostrar_filtros = !this.pesq_pro_mostrar_filtros;
    },
    
    pesqProAtualizarDefinicaoFiltro() {
      this.pesq_pro_titulo_filtro_1 = this.pesq_pro_tipos_pesquisa[this.pesq_pro_opcao_filtro].titulo_1;
      this.pesq_pro_texto_placeholder_1 = this.pesq_pro_tipos_pesquisa[this.pesq_pro_opcao_filtro].placeholder_1;
      this.pesq_pro_tamanho_maximo_1 = this.pesq_pro_tipos_pesquisa[this.pesq_pro_opcao_filtro].tamanho_maximo_1;

      let trocouTipoCampo1 = (this.pesq_pro_filtro_1_inteiro != (this.pesq_pro_tipos_pesquisa[this.pesq_pro_opcao_filtro].tipo_filtro_1 == "I"));

      this.pesq_pro_filtro_1_inteiro = (this.pesq_pro_tipos_pesquisa[this.pesq_pro_opcao_filtro].tipo_filtro_1 == "I");

      if (this.pesq_pro_filtro_1_inteiro) {
        this.pesq_pro_tipo_campo_1 = "number";
      } else {
        this.pesq_pro_tipo_campo_1 = "text";
      }

      if (trocouTipoCampo1) {
        if (this.pesq_pro_filtro_1_inteiro) {
          if ((this.pesq_pro_filtro_literal_1 != undefined) && (this.pesq_pro_filtro_literal_1 != '')) {
            this.pesq_pro_filtro_numerico_1 = parseInt(this.pesq_pro_filtro_literal_1);
          }
        } else {
          if ((this.pesq_pro_filtro_numerico_1 != undefined) && ((this.pesq_pro_filtro_numerico_1) > 0)) {
            this.pesq_pro_filtro_literal_1 = this.pesq_pro_filtro_numerico_1.toUppperCase();
          }
        }
      }

      this.pesq_pro_tem_filtro_2 = (this.pesq_pro_tipos_pesquisa[this.pesq_pro_opcao_filtro].quantidade_campos > 1);
      if (this.pesq_pro_tem_filtro_2) {
        this.pesq_pro_titulo_filtro_2 = this.pesq_pro_tipos_pesquisa[this.pesq_pro_opcao_filtro].titulo_2;
        this.pesq_pro_texto_placeholder_2 = this.pesq_pro_tipos_pesquisa[this.pesq_pro_opcao_filtro].placeholder_2;
      }
    },
    
    async pesqProPesquisar(){
      try {
        if (this.pesq_pro_filtro_digitado_1.length < 1 || this.pesq_pro_filtro_digitado_1 == '') {
          Biblioteca.exclamar('É necessário digitar no mínimo 1 caracteres de pesquisa!');
          return;
        }

        this.pesq_pro_produtos_filtrados = [];
        this.pesq_pro_processando = true;
        this.produtos_filtrados = [];

        let parametros = {
          tipo_pesquisa: this.pesq_pro_tipos_pesquisa[this.pesq_pro_opcao_filtro].tipo,
          chave_pesquisa_1: this.pesq_pro_filtro_digitado_1.toUpperCase(),
          chave_pesquisa_2: this.pesq_pro_filtro_digitado_2.toUpperCase(),
          filtro_somente_ativos: booleanToChar(this.pesq_pro_filtro_somente_ativos),
          filtro_pesquisa_compra: 'N',
          filtro_somente_pais: 'N',
          filtro_trazer_kit: booleanToChar(this.pesq_pro_filtro_trazer_kit),
          filtro_somente_revenda: booleanToChar(this.pesq_pro_filtro_somente_revenda),
          filtro_somente_uso_consumo: booleanToChar(this.pesq_pro_filtro_somente_uso_consumo),
          filtro_somente_brinde_profissional: booleanToChar(this.pesq_pro_filtro_permitir_brinde_profissional),
          filtro_somente_ativos_imobilizados: 'N',
          filtro_somente_servicos: 'N',
          filtro_somente_cesta_basica: booleanToChar(this.pesq_pro_filtro_somente_cesta_basica),
        }
      
        let retorno = await RProdutoBuscarProdutoPesquisa.buscarProdutosPesquisa(this.axios, parametros);

        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        this.pesq_pro_produtos_filtrados = Object.assign([], retorno.dados);
        this.pesq_pro_processando = false;
      } catch (e) {
        this.pesq_pro_processando = false;
        Biblioteca.exclamar(e.message);
      }
    },
    
    pesqProDefinirPesquisa(indice) {
      this.pesq_pro_mostrar_filtros = true;
      this.pesq_pro_opcao_filtro = indice;
      this.pesqProAtualizarDefinicaoFiltro();
    },
  }
}
</script>

<style scoped>
  canvas.drawing, canvas.drawingBuffer {
    position: absolute;
    left: 0;
    top: 0;
  }

  .titulo{
    border-bottom: 1px solid #9c1d1c;
    margin-bottom: 20px;
    text-align: left;
  }

  .line-item {
    border-bottom: 1px solid #000;
  }

  .align-button-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .input-upper {
    text-transform: uppercase;
  }

  .input-upper::placeholder {
    text-transform: capitalize;
  }

  @media screen and (max-width: 1199px){
    .w3-padding-right:nth-child(2){
      padding-right: 0 !important
    }
  }

  @media screen and (max-width: 767px){
    .w3-padding-right{
      padding-right: 0 !important
    }
    
    .drop-down-left {
      right: -22%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Contagens.vue